import {
  SwipeableDots,
  SwipeableProgressRatio,
  SwipeableProvider,
  SwipeableSlider,
} from '@jouzen/ecom-components/v3/SwipeableSlider';

import MobileTestimonialCard from './MobileTestimonialCard';
import type {
  LandingPageTestimonial,
  LandingPageTestimonialsTheme,
} from './types';

export interface MobileTestimonialCardsProps {
  readonly inverted: boolean;
  readonly testimonials: LandingPageTestimonial[];
  readonly theme: LandingPageTestimonialsTheme;
}

const MobileTestimonialCards = ({
  inverted,
  testimonials,
  theme,
}: MobileTestimonialCardsProps) => {
  return (
    <SwipeableProvider>
      <div className="flex flex-col-reverse gap-y-4 lg:hidden">
        <div className="mr-6 flex justify-between">
          <SwipeableProgressRatio color={inverted ? 'light' : 'dark'} />
          <SwipeableDots
            activeColor={inverted ? 'gray-200' : 'gray-300'}
            color={inverted ? 'gray-400' : 'sandstone-500'}
          />
        </div>
        <SwipeableSlider className="pr-6">
          {testimonials.map(({ id, ...testimonial }) => (
            <MobileTestimonialCard
              {...testimonial}
              inverted={inverted}
              key={id}
              theme={theme}
            />
          ))}
        </SwipeableSlider>
      </div>
    </SwipeableProvider>
  );
};

export default MobileTestimonialCards;
